import { CONFIGS, useConfigQuery } from '@buildwise/libs/configurations';
import useUserData from 'hooks/useUserData';
import { ReactNode, useMemo } from 'react';
import { ReactComponent as Progress3LineIcon } from 'assets/icons/Progress3LineIcon.svg';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import { theme } from 'config/theme';
import CheckboxCircleFillIcon from 'remixicon-react/CheckboxCircleFillIcon';
import ArchiveFillIcon from 'remixicon-react/ArchiveFillIcon';

type RenderSuggestionStatusProps = {
  status: string;
};

function RenderSuggestionStatus({ status }: RenderSuggestionStatusProps) {
  const { companyId } = useUserData();
  const { entries } = useConfigQuery({
    companyId,
    configName: CONFIGS.SUGGESTION_STATUSES.configName,
  });
  const { statusDisplayName, statusIcon } = useMemo(() => {
    const statusDisplayName =
      entries.find((entry) => entry.entryCode === status)?.entryDescription || status;
    let statusIcon: ReactNode = null;

    switch (status) {
      case 'INPROGRESS': {
        statusIcon = <Progress3LineIcon width={20} color={theme.palette.custom.mistBlue} />;
        break;
      }

      case 'COMPLETED': {
        statusIcon = <CheckboxCircleFillIcon size={20} color={theme.palette.custom.greenBlue} />;
        break;
      }

      case 'ARCHIVED': {
        statusIcon = <ArchiveFillIcon size={20} color={theme.palette.custom.mistBlue} />;
        break;
      }

      default: {
        statusIcon = null;
      }
    }

    return {
      statusDisplayName,
      statusIcon,
    };
  }, [entries, status]);

  return (
    <Box display="flex" alignItems="center" gap={0.5} mt={0.5}>
      {statusIcon}
      <Typography
        component="span"
        sx={(theme) => ({ color: theme.palette.custom.mistBlue, fontSize: 14 })}
      >
        {statusDisplayName}
      </Typography>
    </Box>
  );
}

export default RenderSuggestionStatus;
